import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderMiradas } from "../../../components/Landing/Header/headerMiradas";
import { Footer } from "../../../components/Landing/Footer";
import { SEO } from "../../../components/SEO/SEO";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import banner2026 from "../../../assets/miradas/banner2026.png";
import talentosImg from "../../../assets/talentos.jpeg";
import talleresImg from "../../../assets/talleres.jpg";

// Documento (Drive) de la programación de Días de Industria. Se guarda solo el
// identificador: de él salen la vista incrustada y el enlace para abrirlo.
// Debe estar compartido con "cualquiera con el enlace" para que el preview cargue.
const DIAS_INDUSTRIA_DRIVE_ID = "1BTq4C81-SjhqjmfaOmV6vb0arOQUQQrY";

// Formulario de inscripción a los Encuentros.
const ENCUENTROS_FORM_URL = "https://forms.gle/FGzJNYf34aVTpJQM8";

export const MiradasIndustria = () => {
  const navigate = useNavigate();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  return (
    <>
      <SEO
        title="Industria Miradas Medellín"
        description="En Miradas Medellín creamos espacios de formación audiovisual, desarrollo de proyectos y relacionamiento profesional dirigidos a estudiantes y creadores."
        keywords="industria Miradas Medellín, formación audiovisual, desarrollo de proyectos, talento audiovisual , Encuentro Coproducción"
        ogTitle="Industria Miradas Medellín"
        ogDescription="Creamos espacios de formación audiovisual, desarrollo de proyectos y relacionamiento profesional en Miradas Medellín."
        ogUrl={`${window.location.origin}/estimuloscultura/miradasIndustria`}
      />
      <Header />
      <HeaderMiradas />
      <img src={banner2026} alt="Miradas Medellín 2026" style={{ width: "100%", height: "auto", objectFit: "cover" }} />

      {/* SECCIÓN 1: INTRODUCCIÓN */}
      <div className="container-fluid2" style={{ maxWidth: "800px", margin: "0 auto", padding: "60px 20px" }}>
        <h1 className="sr-only">Industria Miradas Medellín</h1>
        <h2 className="mb-4" style={{ fontWeight: "bold", fontSize: "28px", color: "#000", textAlign: "center" }}>
          Un espacio para crear, aprender y conectar
        </h2>
        <div style={{ fontSize: "16px", textAlign: "justify", color: "#333", lineHeight: "1.6" }}>
          <p className="mb-4">
            En Miradas Medellín creamos espacios de formación audiovisual, desarrollo de proyectos y relacionamiento profesional dirigidos a estudiantes, nuevos talentos, realizadores, productores y personas interesadas en el sector audiovisual.
          </p>
          <p className="mb-4">
            A través de nuestra agenda de industria, promovemos el intercambio de conocimientos, el fortalecimiento creativo y la construcción de redes de colaboración entre profesionales locales, nacionales e internacionales.
          </p>
          <p>
            Generamos escenarios donde las ideas se transforman en proyectos, los proyectos encuentran nuevas conexiones y las alianzas fortalecen el desarrollo del cine iberoamericano.
          </p>
        </div>
      </div>

      {/* SECCIÓN 1b: PROGRAMACIÓN DE DÍAS DE INDUSTRIA + INSCRIPCIÓN A ENCUENTROS */}
      <div style={{ padding: "40px 20px", borderTop: "1px solid #eee" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ fontWeight: "bold", fontSize: "24px", color: "#000", marginBottom: "20px" }}>
            Programación de Días de Industria
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "30px", color: "#333" }}>
            Consulta aquí la programación completa de los Días de Industria de Miradas Medellín 2026.
          </p>

          {/* La programación, para leerla sin salir de la página. */}
          <div style={{ backgroundColor: "white", borderRadius: "8px", overflow: "hidden", marginBottom: "30px" }}>
            <iframe
              src={`https://drive.google.com/file/d/${DIAS_INDUSTRIA_DRIVE_ID}/preview`}
              title="Programación de Días de Industria - Miradas Medellín 2026"
              style={{ width: "100%", height: "70vh", minHeight: "420px", border: "none", display: "block" }}
              allow="autoplay"
            />
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", justifyContent: "center" }}>
            <Button
              type="primary"
              href={ENCUENTROS_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 30px', borderRadius: '5px' }}
            >
              Inscríbete aquí a los Encuentros
            </Button>
          </div>
        </div>
      </div>

      {/* SECCIÓN 2: PROGRAMA DE TALENTOS */}
      <div style={{ padding: "40px 20px", borderTop: "1px solid #eee" }}>
        <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <h2 className="mb-5 text-center" style={{ fontWeight: "bold", fontSize: "26px", color: "#000" }}>
            Programa de Talentos Miradas Medellín
          </h2>
          <div className="row">
            <div className="col-md-6 pr-md-4">
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "20px" }}>
                Programa de formación audiovisual dirigido a estudiantes de cine, nuevos profesionales y personas que comienzan su trayectoria en el sector audiovisual.
              </p>
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "20px" }}>
                A través de clases magistrales, talleres especializados, conversaciones con invitados y espacios de intercambio profesional, el Programa de Talentos fortalece conocimientos técnicos, creativos y críticos mediante la transferencia de experiencias de cineastas y profesionales nacionales e internacionales.
              </p>
              <p style={{ fontSize: "15px", marginBottom: "15px" }}>Entre sus actividades se encuentran:</p>
              <ul style={{ fontSize: "15px", paddingLeft: "20px", marginBottom: "30px", listStyleType: "disc" }}>
                <li>Clases magistrales y encuentros académicos.</li>
                <li>Talleres especializados en distintas áreas del audiovisual.</li>
                <li>Conversaciones con cineastas invitados.</li>
                <li>Foros sobre tendencias de la industria audiovisual.</li>
                <li>Espacios de relacionamiento entre participantes e invitados.</li>
              </ul>
            </div>
            <div className="col-md-6 mt-4 mt-md-0 pl-md-4">
              <img src={talentosImg} alt="Poster Talentos Miradas" style={{ width: "100%", height: "100%", minHeight: "400px", objectFit: "cover", borderRadius: "5px" }} />
            </div>
          </div>
        </div>
      </div>
      {/* SECCIÓN 4: ENCUENTRO DE COPRODUCCIÓN */}
      <div style={{ padding: "60px 20px", borderTop: "1px solid #eee" }}>
        <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <h2 className="mb-5 text-center" style={{ fontWeight: "bold", fontSize: "26px", color: "#000" }}>
            Encuentro de Coproducción
          </h2>
          <div className="row">
            <div className="col-md-6 pr-md-4">
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "20px" }}>
                Programa de fortalecimiento para productores locales, nacionales e internacionales con proyectos en desarrollo y potencial de coproducción iberoamericana.
              </p>
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "20px" }}>
                A través de mentorías, análisis de proyectos, estudios de caso y conversaciones especializadas, el Encuentro de Coproducción promueve la creación de alianzas estratégicas y el intercambio de experiencias alrededor de la financiación, producción y circulación de obras audiovisuales.
              </p>
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "20px" }}>
                Su propósito es fortalecer la colaboración entre profesionales y generar nuevas oportunidades para el desarrollo de proyectos cinematográficos con alcance internacional.
              </p>
              <p style={{ fontSize: "15px", marginBottom: "15px" }}>Incluye:</p>
              <ul style={{ fontSize: "15px", paddingLeft: "20px", marginBottom: "30px", listStyleType: "disc" }}>
                <li>Clases maestras.</li>
                <li>Sesiones de análisis y seguimiento de proyectos.</li>
                <li>Estudios de caso.</li>
                <li>Conversaciones.</li>
                <li>Espacios de relacionamiento profesional.</li>
              </ul>
            </div>
            <div className="col-md-6 mt-4 mt-md-0 pl-md-4">
              <img src={talleresImg} alt="Poster Encuentro de Coproducción" style={{ width: "100%", height: "100%", minHeight: "400px", objectFit: "cover", borderRadius: "5px" }} />
            </div>
          </div>
        </div>
      </div>

      {/* SECCIÓN 5: MERCADO AUDIOVISUAL */}
      <div style={{ padding: "60px 20px", borderTop: "1px solid #eee" }}>
        <div className="container-fluid2" style={{ maxWidth: "1000px", margin: "0 auto" }}>
          <div className="row align-items-center">
            <div className="col-md-5">
              <h2 style={{ fontWeight: "bold", fontSize: "28px", color: "#000", marginBottom: "10px" }}>
                Mercado audiovisual<br />y oportunidades de<br />inversión
              </h2>
              <h3 style={{ fontSize: "20px", color: "#444", marginBottom: "0" }}>
                Rueda de negocios
              </h3>
            </div>
            <div className="col-md-7 mt-4 mt-md-0 pl-md-5">
              <p style={{ fontSize: "15px", textAlign: "justify", marginBottom: "20px" }}>
                Diseñada y operada por la Comisión Fílmica de Medellín, la Rueda de Negocios conecta proyectos audiovisuales con potenciales aliados, inversionistas y oportunidades de desarrollo.
              </p>
              <p style={{ fontSize: "15px", textAlign: "justify", margin: "0" }}>
                Este espacio fortalece el componente de Mercado de Miradas Medellín promoviendo nuevas oportunidades para la financiación y circulación de proyectos audiovisuales.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* SECCIÓN 6: EXPLORA EXPERIENCIA */}
      <div style={{ padding: "40px 20px 80px 20px", backgroundColor: "#f9f9f9" }}>
        <div className="container-fluid2 text-center" style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2 style={{ fontWeight: "bold", fontSize: "24px", color: "#000", marginBottom: "20px" }}>
            Explora toda la experiencia Miradas Medellín
          </h2>
          <p style={{ fontSize: "16px", marginBottom: "30px", color: "#333" }}>
            Consulta la programación del festival y descubre las películas, actividades y experiencias abiertas a la ciudadanía.
          </p>
          <Button
            type="primary"
            style={{ backgroundColor: '#2e66d2', borderColor: '#2e66d2', fontSize: '16px', fontWeight: "bold", height: 'auto', padding: '10px 30px', borderRadius: '5px' }}
            onClick={() => handleNavigation('/miradasProgramacion')}
          >
            Ver programación
          </Button>
        </div>
      </div>

      <Footer />
    </>
  );
};